module.exports = __webpack_public_path__ + "img/1-find.c35fa6f8.svg";